import { AxiosHttpClient } from 'api/axios';
import { FetchUserReservationsParams, ReservationsResponse } from 'entities/reservation';
import { QueryFunction, QueryFunctionContext, QueryKey, useQuery } from 'react-query';

/**
 * マイカレンダー > 全て (自分のみでない) > reservations一覧の取得
 */
export const useFetchLaboratoryReservationsQuery = (initParams: FetchUserReservationsParams) => {
  const client = new AxiosHttpClient('user');
  const getStockItems: QueryFunction<FetchUserReservationsParams> = async ({
    pageParam = initParams,
  }: QueryFunctionContext<QueryKey, FetchUserReservationsParams>) => {
    const { data } = await client.get('laboratories/reservations', {
      ...pageParam,
    });
    return data;
  };

  const query = useQuery<FetchUserReservationsParams, undefined, ReservationsResponse>(
    `use_search_items_laboratory_room_${initParams.roomId}_instrument_category_${initParams.instrumentCategoryId}_query`,
    getStockItems,
    {
      enabled: false,
    }
  );

  return query;
};
